import * as React from 'react'
import {
  Inset,
  StackChildren,
  Text,
  Colors,
  Stack,
} from '@doordash/design-language'
import { OppositeHeadings } from './styles'
import DateStoreNameHeading, {
  DateStoreHeadingType,
} from '../components/DateStoreHeading'
import { countMissedSteps } from '../utilities'
import DeliveryIssueStep, { StepPositions } from './DeliveryIssueStep'
import { DeliveryIssueStep as DeliveryIssueStepType } from '../../../../models/types'
import t from './strings'

type StepProps = {
  steps: DeliveryIssueStepType[]
}

export const Steps: React.FC<StepProps> = ({ steps }) => (
  <Stack size={Stack.Sizes.XxSmall}>
    {steps.map(({ type, result }, index) => {
      let position = StepPositions.Other
      if (index === 0) {
        position = StepPositions.First
      }
      if (index === steps.length - 1) {
        position = StepPositions.Last
      }
      return (
        <DeliveryIssueStep
          key={type}
          type={type}
          result={result}
          position={position}
        />
      )
    })}
  </Stack>
)

type DeliveryIssueNeverDeliveredCardProps = {
  storeHeading: DateStoreHeadingType
  steps: DeliveryIssueStepType[]
}

export const DeliveryIssueNeverDeliveredCard: React.FC<DeliveryIssueNeverDeliveredCardProps> = ({
  storeHeading,
  steps,
}) => {
  return (
    <React.Fragment>
      <Inset isSquished={true}>
        <DateStoreNameHeading {...storeHeading} />
        <StackChildren size={StackChildren.Sizes.XxSmall}>
          <OppositeHeadings>
            <Text styles={Text.Styles.PageTitle}>
              {t.requiredStepsTitleText()}
            </Text>
            <Text styles={Text.Styles.Bold14} color={Colors.TextCallout}>
              {t.missingSteps({
                missed: `${countMissedSteps(steps).missed}`,
                total: `${countMissedSteps(steps).total}`,
              })}
            </Text>
          </OppositeHeadings>
        </StackChildren>
        <Text styles={Text.Styles.PageSubtext}>
          {t.requiredStepsDescriptionText()}
        </Text>
      </Inset>
      {steps && <Steps steps={steps} />}
    </React.Fragment>
  )
}

export default DeliveryIssueNeverDeliveredCard
